var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!this.$route.params.id)?_c('p',[_vm._v("No track id specified")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }